export default __webpack_public_path__ + "static/auftrag-1bd8ef30cb74c8f51b41d447e44df352.gif";